<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-row style="font-weight:bold;">
            <center>公司名称</center>
          </el-row>
          <div class="padding15-tb">
            <el-row style="font-weight:bold;">
              <el-select v-model="company.companySelected" filterable placeholder="请选择公司" style="width: 100%;" @change="companyChange" clearable>
                <el-option v-for="item in company.companyOption" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-row>
            <el-row style="font-weight:bold;">
              <el-select v-model="group.groupSelected" filterable placeholder="请选择策略组" @change="companyListQuery" style="width: 100%;" clearable>
                <el-option
                  v-for="item in group.groupOption"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-row>
            <el-row style="font-weight:bold;">
              <el-select v-model="supplier.supplierSelected" filterable placeholder="请选择线路" @change="companyListQuery" style="width: 100%;" clearable>
                <el-option
                  v-for="item in supplier.supplierOption"
                  :key="item.id"
                  :label="item.supplierName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-row>
          </div>
          <div style="overflow-x: hidden; overflow-y:auto;height: 80%;margin-top: 10px;">
            <el-menu style="height: 650px; width: 100%;" class="el-menu-call">
              <el-radio-group v-model="currentCompanyIdType" @change="companyDetail($event, 0)" style="width: 100%;">
                <el-menu-item
                  v-for="data in companiesWithoutGroup"
                  :key="`company_leaf_${data.id}`"
                  style="padding-left: 0px;"
                  :index="`0_${data.id}_0`">
                  <el-radio :label="`0_${data.id}_0_0`">{{data.companyName}}</el-radio>
                </el-menu-item>
                <el-submenu
                  v-for="data in companiesWithGroup"
                  :key="`company_branch_${data.id}`"
                  :index="`0_${data.id}_0`">
                  <template slot="title">
                    <span class="node-name">
                      <el-radio style="padding-left: 0px;" :label="`0_${data.id}_0_0`">
                        <el-tooltip :content="data.companyName" placement="top">
                          <span class="truncated-text">{{data.companyName}}</span>
                        </el-tooltip>
                        <span class="field-label">
                        {{ data.isGroupSetting ? `(${getActiveChildrenCount(data)}/${data.groupList.length})` : ''}}
                        </span>
                      </el-radio>
                    </span>
                  </template>
                  <el-radio-group v-model="currentCompanyIdType" @change="companyDetail($event, 1)">
                    <el-menu-item
                      v-for="children in data.groupList"
                      :key="`group_item_${children.id}`"
                      style="padding-left: 20px;"
                      :index="`1_${data.id}_${children.id}`">
                      <el-radio :label="`1_${data.id}_${children.id}_${children.isGroupSettingOpen}`">
                        <span :class="{'is-closed': !children.isGroupSettingOpen}">{{children.groupName}}</span>
                        <span style="color: red; font-weight: 400; font-size: 12px;" v-if='!children.isGroupSettingOpen'>（已关闭）</span>
                      </el-radio>
                    </el-menu-item>
                  </el-radio-group>
                </el-submenu>
              </el-radio-group>
            </el-menu>
          </div>
        </el-col>
        <el-col :span="1">
          &nbsp;
        </el-col>
        <el-col :span="17">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="短信" name="msg">
              <el-button type="primary" size="mini" style="margin-left: 90%; margin-top: 5px; margin-bottom: 5px;" @click="modifyCustomerConf('msg', '短信')">提交短信</el-button>
              <el-table :data="messageRes.filter(item => item.type === 'msg')" height="720" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="80">
                  <template slot-scope="scope">
                    <span>短信</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0 ? true : false"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column property="unitPrice" label="线路单价(元)" min-width="100"/>
                <el-table-column label="是否有资源" min-width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isResource === false">否</div>
                    <div v-if="scope.row.isResource === true">是</div>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" selected label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="闪信" name="fmsg">
              <el-button type="primary" size="mini" style="margin-left: 90%; margin-top: 5px; margin-bottom: 5px;" @click="modifyCustomerConf('fmsg', '闪信')">提交闪信</el-button>
              <el-table :data="messageRes.filter(item => item.type === 'fmsg')" height="720" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="80">
                  <template slot-scope="scope">
                    <span>闪信</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0 ? true : false"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column property="unitPrice" label="线路单价(元)" min-width="100"/>
                <el-table-column label="是否有资源" min-width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isResource === false">否</div>
                    <div v-if="scope.row.isResource === true">是</div>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" selected label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="语音" name="ivr">
              <el-button type="primary" size="mini" style="margin-left: 90%; margin-top: 5px; margin-bottom: 5px;" @click="modifyCustomerConf('ivr', '语音')">提交语音</el-button>
              <el-table :data="messageRes.filter(item => item.type === 'ivr')" height="720" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="80">
                  <template slot-scope="scope">
                    <span>语音</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0 ? true : false"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column property="unitPrice" label="线路单价(元)" min-width="100"/>
                <el-table-column label="是否有资源" min-width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isResource === false">否</div>
                    <div v-if="scope.row.isResource === true">是</div>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" selected label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="智能语音" name="ivoice">
              <el-button type="primary" size="mini" style="margin-left: 85%; margin-top: 5px; margin-bottom: 5px;" @click="modifyCustomerConf('ivoice', '智能语音')">提交智能语音</el-button>
              <el-table :data="messageRes.filter(item => item.type === 'ivoice')" height="720" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="80">
                  <template slot-scope="scope">
                    <span>智能语音</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0 ? true : false"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column property="unitPrice" label="线路单价(元)" min-width="100"/>
                <el-table-column label="是否有资源" min-width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isResource === false">否</div>
                    <div v-if="scope.row.isResource === true">是</div>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" selected label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="场景语音" name="svoice">
              <el-button type="primary" size="mini" style="margin-left: 85%; margin-top: 5px; margin-bottom: 5px;" @click="modifyCustomerConf('svoice', '场景语音')">提交场景语音</el-button>
              <el-table :data="messageRes.filter(item => item.type === 'svoice')" height="720" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="80">
                  <template slot-scope="scope">
                    <span>场景语音</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0 ? true : false"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column property="unitPrice" label="线路单价(元)" min-width="100"/>
                <el-table-column label="是否有资源" min-width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.isResource === false">否</div>
                    <div v-if="scope.row.isResource === true">是</div>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" selected label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <el-row>
        <div style="margin-top: 0">
          <el-button type="primary" round icon="el-icon-folder-add" @click="addCustomerConfShow(0)">公司</el-button>
          <el-button type="success" round icon="el-icon-plus" @click="addCustomerConfShow(1)">策略</el-button>
          <el-button type="danger" round icon="el-icon-delete" style="margin-left: 10px;" @click="delCustomerConf">删除</el-button>
          <el-button type="primary" round icon="el-icon-copy-document" style="margin-left: 10px;" @click="openCopyConfDialog">复制</el-button>
          <el-button v-if="currentStatus === 'false'" type="primary" icon="el-icon-open" round style="margin-left: 10px;" @click="updateStatusCustomerConf(true)">开启</el-button>
          <el-button v-if="currentStatus === 'true'" type="warning" icon="el-icon-open" round style="margin-left: 10px;" @click="updateStatusCustomerConf(false)">关闭</el-button>
        </div>
      </el-row>
      <el-row>
        <el-button type="primary" size="mini" style="margin-left: 48%; margin-top: 20px;" @click="modifyCustomerConf('all')">统一提交</el-button>
      </el-row>
    </div>
    <!-- 新增-公司 -->
    <el-dialog
      title="请选择呼叫平台需要设置为自定义的公司"
      :visible.sync="customerConfigure"
      width="60%"
      center>
      <div>
        <el-form size="small" label-width="180px">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="公司名称" label-width="80px" style="margin-left: -10px;">
                <el-select v-model="companyId" filterable collapse-tags placeholder="请选择" style="width: 100%;">
                  <el-option v-for="item in noneCompanies" :key="item.id" :label="item.companyName" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-tabs v-model="activeTabAdd">
            <el-tab-pane label="短信" name="msg">
              <el-table :data="serversRes.filter(item => item.type === 'msg')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>短信</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="闪信" name="fmsg">
              <el-table :data="serversRes.filter(item => item.type === 'fmsg')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>闪信</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="语音" name="ivr">
              <el-table :data="serversRes.filter(item => item.type === 'ivr')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>语音</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="智能语音" name="ivoice">
              <el-table :data="serversRes.filter(item => item.type === 'ivoice')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>智能语音</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="场景语音" name="svoice">
              <el-table :data="serversRes.filter(item => item.type === 'svoice')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>场景语音</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerConfigure = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="addCustomerConf(0)">保存</el-button>
      </div>
    </el-dialog>
    <!-- 新增-策略组 -->
    <el-dialog
      title="请选择呼叫平台需要设置为自定义的策略组"
      :visible.sync="customerConfigureGroup"
      width="60%"
      center>
      <div>
        <el-form size="small" label-width="180px">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-form-item label="公司名称" label-width="80px" style="margin-left: -10px;">
                <el-select v-model="companyId" filterable collapse-tags placeholder="请选择" style="width: 100%;" @change="companyChangeGroup">
                  <el-option v-for="item in companyAddOption" :key="item.id" :label="item.companyName" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="策略组名" label-width="80px" style="margin-left: -10px;">
                <el-select v-model="groupId" filterable collapse-tags placeholder="请选择" style="width: 100%;">
                  <el-option v-for="item in groupAddOption" :key="item.id" :label="item.groupName" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-tabs v-model="activeTabAdd">
            <el-tab-pane label="短信" name="msg">
              <el-table :data="serversRes.filter(item => item.type === 'msg')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>短信</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="闪信" name="fmsg">
              <el-table :data="serversRes.filter(item => item.type === 'fmsg')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>闪信</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="语音" name="ivr">
              <el-table :data="serversRes.filter(item => item.type === 'ivr')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>语音</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="智能语音" name="ivoice">
              <el-table :data="serversRes.filter(item => item.type === 'ivoice')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>智能语音</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="场景语音" name="svoice">
              <el-table :data="serversRes.filter(item => item.type === 'svoice')" height="300" border style="width: 100%">
                <el-table-column prop="supplierName" label="服务名称" min-width="180"/>
                <el-table-column label="类型" min-width="100">
                  <template slot-scope="scope">
                    <span>场景语音</span>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="scope.row.status === 0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="150">
                  <template slot-scope="scope">
                    <el-select :value="scope.row.status" v-model="scope.row.status">
                      <el-option :value="0" label="禁用"/>
                      <el-option :value="1" label="启用"/>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerConfigureGroup = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="addCustomerConf(1)">保存</el-button>
      </div>
    </el-dialog>
    <!-- 复制配置-->
    <el-dialog
      title="复制配置"
      :visible.sync="copyConfigDialogEnable"
      class="copy-config-centered"
      center>
      <el-form
        :model="copyConfigForm"
        :rules="copyConfigFormRules"
        ref="copyConfigForm"
        label-position="right"
        label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="来源公司名称" prop="sourceCompanyId">
              <el-select
                v-model="copyConfigForm.sourceCompanyId"
                filterable
                collapse-tags
                placeholder="请选择"
                @change="companyChangeOnCopyDialog(0)"
                style="width: 100%;">
                <el-option v-for="item in company.companyOption" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="来源策略名称" prop="sourceGroupId">
              <el-select
                v-model="copyConfigForm.sourceGroupId"
                filterable
                clearable
                collapse-tags
                placeholder="请选择"
                style="width: 100%;">
                <el-option v-for="item in copyConfigSourceGroupOptions" :key="item.id" :label="item.groupName" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="类型" prop="types">
              <el-select
                v-model="copyConfigForm.types"
                clearable
                multiple
                collapse-tags
                :collapse-tags-limit="2"
                placeholder="请选择类型"
                style="width: 100%;">
                <el-option
                  v-for="item in strategyTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="目标公司名称" prop="targetCompanyId">
              <el-select
                v-model="copyConfigForm.targetCompanyId"
                filterable
                collapse-tags
                placeholder="请选择"
                @change="companyChangeOnCopyDialog(1)"
                style="width: 100%;">
                <el-option v-for="item in company.companyOption" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="目标策略名称" prop="targetGroupIds">
              <el-select
                v-model="copyConfigForm.targetGroupIds"
                filterable
                clearable
                collapse-tags
                multiple
                :collapse-tags-limit="2"
                placeholder="请选择"
                style="width: 100%;">
                <el-option v-for="item in copyConfigTargetGroupOptions" :key="item.id" :label="item.groupName" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCopyConfigDialog">取消</el-button>
        <el-button type="primary" @click="submitCopyConfig">确认</el-button>
      </div>
    </el-dialog>

    <router-view v-if="reload"></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      customerConfigure: false,
      customerConfigureGroup: false,
      copyConfigDialogEnable: false,
      // 复制配置表单
      copyConfigForm: {
        sourceCompanyId: null,
        sourceGroupId: null,
        types: [],
        targetCompanyId: null,
        targetGroupIds: []
      },
      copyConfigSourceGroupOptions: [],
      copyConfigTargetGroupOptions: [],
      strategyTypeOptions: [
        {
          label: '短信',
          value: 'msg'
        }, {
          label: '闪信',
          value: 'fmsg'
        }, {
          label: '语音',
          value: 'ivr'
        }, {
          label: '智能语音',
          value: 'ivoice'
        }, {
          label: '场景语音',
          value: 'svoice'
        }
      ],
      copyConfigFormRules: {
        sourceCompanyId: [
          { required: true, message: '请选择来源公司', trigger: 'change' }
        ],
        types: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        targetCompanyId: [
          { required: true, message: '请选择目标公司', trigger: 'change' }
        ]
      },
      activeTab: 'msg',
      activeTabAdd: 'msg',
      // 已经新增过配置的公司
      addedCompanies: [],
      // 无新增配置的公司
      noneCompanies: [],
      // 配置列表
      serversRes: [],
      messageRes: [],
      // message: [
      //   {
      //     'label': '短信',
      //     'value': 'msg',
      //     'list': []
      //   }, {
      //     'label': '语音',
      //     'value': 'ivr',
      //     'list': []
      //   }, {
      //     'label': '智能语音',
      //     'value': 'ivoice',
      //     'list': []
      //   }, {
      //     'label': '场景语音',
      //     'value': 'svoice',
      //     'list': []
      //   }
      // ],
      currentCompanyIdType: '',
      currentCompanyId: null,
      currentGroupId: 0,
      currentScopeType: 0,
      currentStatus: '0',
      companyId: null,
      companyAddOption: [],
      groupId: null,
      groupAddOption: [],
      reload: false,
      companyName: '',
      supplierName: '',
      company: {
        companySelected: null,
        companyOption: []
      },
      group: {
        groupSelected: null,
        groupOption: []
      },
      supplier: {
        supplierSelected: null,
        supplierOption: []
      },
      groupReq: {
        companyId: '',
        isFilterGroupSetting: false
      },
      defaultProps: {
        children: 'children',
        label: 'name1'
      },
      selectedNode: null
    };
  },
  computed: {
    companiesWithoutGroup() {
      return this.addedCompanies.filter(item => !item.groupList || item.groupList.length === 0);
    },
    companiesWithGroup() {
      return this.addedCompanies.filter(item => item.groupList && item.groupList.length > 0);
    }
  },
  methods: {
    // 打开复制策略组配置弹框
    openCopyConfDialog() {
      this.copyConfigDialogEnable = true;
    },
    companyChangeOnCopyDialog(scope) {
      if (scope === 0) {
        if (!this.copyConfigForm || !this.copyConfigForm.sourceCompanyId) {
          this.$confirm('请选择来源公司', '提示', {
            confirmButtonText: '知道了',
            type: 'warning'
          });
          return;
        }
        this.copyConfigForm.sourceGroupId = null;
        this.$ajax({
          method: 'POST',
          data: {
            companyId: this.copyConfigForm.sourceCompanyId
          },
          url: '/company/listQuery'
        }).then((res) => {
          if (!res.data || res.data.length === 0) {
            return;
          }
          this.copyConfigSourceGroupOptions = res.data[0].groupList;
        });
      } else if (scope === 1) {
        let groupReq = {};
        if (!this.copyConfigForm || !this.copyConfigForm.targetCompanyId) {
          this.$confirm('请选择目标公司公司', '提示', {
            confirmButtonText: '知道了',
            type: 'warning'
          });
          return;
        }
        this.copyConfigForm.targetGroupIds = [];
        groupReq = {
          companyId: this.copyConfigForm.targetCompanyId,
          isFilterGroupSetting: false
        };
        this.getGroupListOnCopyConfigChange(scope, groupReq);
      }
    },
    submitCopyConfig() {
      this.$refs.copyConfigForm.validate((valid) => {
        if (valid) {
          this.$confirm('请再次核对配置信息，是否确认复制？', '提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submitCopyConfigRequest(this.copyConfigForm);
          });
        }
      });
    },
    closeCopyConfigDialog() {
      this.$refs.copyConfigForm.resetFields();
      this.copyConfigDialogEnable = false;
    },
    submitCopyConfigRequest(data) {
      this.$ajax({
        prompt: true,
        method: 'POST',
        data,
        url: '/externalServicesConf/copyConf'
      }).then((res) => {
        if (res && res.code === 200) {
          this.closeCopyConfigDialog();
          this.companyListQuery();
        }
      });
    },
    // 公司列表查询
    companyListQuery() {
      this.$ajax({
        method: 'POST',
        data: {
          companyId: this.company.companySelected,
          groupId: this.group.groupSelected,
          supplierId: this.supplier.supplierSelected
        },
        url: '/company/listQuery'
      }).then((res) => {
        this.addedCompanies = [];
        res.data.forEach((item) => {
          this.addedCompanies.push(item);
        });
        // 查询后置空数据
        this.currentCompanyId = null;
        this.currentGroupId = 0;
        this.currentScopeType = 0;
        this.currentCompanyIdType = null;
        // this.message[0].list = [];
        // this.message[1].list = [];
        // this.message[2].list = [];
        // this.message[3].list = [];
        this.messageRes = [];
      });
    },
    // 公司列表--区分新增和未新增配置公司
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        res.data.forEach((item) => {
          if (item.isDefSetting) {
            // 未自定义的公司
            this.noneCompanies.push(item);
          }
        });
        this.company.companyOption = res.data;
      });
      // 已自定义的公司左侧列表
      this.$ajax({
        method: 'POST',
        data: {
          companyId: null,
          groupId: null,
          supplierId: null
        },
        url: '/company/listQuery'
      }).then((res) => {
        this.addedCompanies = [];
        res.data.forEach((item) => {
          this.addedCompanies.push(item);
        });
        // 获取第一条数据
        if (this.addedCompanies.length > 0) {
          this.currentCompanyId = this.addedCompanies[0].id;
          this.currentScopeType = 0;
          this.currentGroupId = 0;
          this.currentCompanyIdType = `0_${this.currentCompanyId}_0_0`;
          this.currentStatus = '0';
          this.companyDetail(this.currentCompanyIdType, 0);
        }
      });
    },
    // 查询已自定义公司
    companyListNoAdd() {
      this.$ajax({
        method: 'GET',
        url: '/company/list?defaultSetting=0'
      }).then((res) => {
        this.companyAddOption = res.data;
      });
    },
    // 公司配置列表
    companyDetail(companyIdType, scopeType) {
      const params = companyIdType.split('_');
      const companyId = Number(params[1]);
      const groupId = Number(params[2]);
      this.currentStatus = params[3];
      this.currentCompanyIdType = companyIdType;
      this.currentScopeType = scopeType;
      this.currentCompanyId = companyId;
      this.currentGroupId = groupId;
      // this.message[0].list = [];
      // this.message[1].list = [];
      // this.message[2].list = [];
      // this.message[3].list = [];
      this.messageRes = [];
      this.$ajax({
        method: 'GET',
        url: `/externalServicesConf/detail/${companyId}/${scopeType}/${groupId}`
      }).then((res) => {
        // this.message[0].list = [];
        // this.message[1].list = [];
        // this.message[2].list = [];
        // this.message[3].list = [];
        // res.data.forEach((item) => {
        //   if (item.type === 'msg') {
        //     this.message[0].list.push(item);
        //   } else if (item.type === 'ivr') {
        //     this.message[1].list.push(item);
        //   } else if (item.type === 'ivoice') {
        //     this.message[2].list.push(item);
        //   } else if (item.type === 'svoice') {
        //     this.message[3].list.push(item);
        //   }
        // });
        this.messageRes = [];
        this.messageRes = res.data;
      });
    },
    // 新增显示
    addCustomerConfShow(scopeType) {
      this.currentScopeType = scopeType;
      if (scopeType === 0) {
        this.customerConfigure = true;
        this.isFilterGroupSetting = false;
        this.companyId = null;
        this.groupId = null;
        this.groupAddOption = [];
        this.serversRes = [];
        this.serverList();
      } else {
        this.customerConfigureGroup = true;
        this.isFilterGroupSetting = true;
        this.companyListNoAdd();
        this.companyId = null;
        this.groupId = null;
        this.groupAddOption = [];
        this.serversRes = [];
        // this.serverList();
      }
    },
    // 服务列表
    serverList() {
      this.$ajax({
        method: 'GET',
        url: '/externalServicesConf/list'
      }).then((res) => {
        this.serversRes = res.data.map(item => ({
          ...item,
          status: 0 // 默认设置为禁用状态
        }));
      });
    },
    // 新增自定义配置
    addCustomerConf(scopeType) {
      if (scopeType === 1) {
        // 添加的策略组
        if (this.groupId === null) {
          this.$confirm('未选择任何策略组,不能添加自定义配置', '提示', {
            confirmButtonText: '知道了',
            type: 'warning'
          });
          return;
        }
      }
      if (this.companyId === null) {
        this.$confirm('未选择任何公司,不能添加自定义配置', '提示', {
          confirmButtonText: '知道了',
          type: 'warning'
        });
        return;
      }
      const list = [];
      this.serversRes.forEach((item) => {
        item.supplierId = item.id;
        if (item.status === 1) {
          list.push(item);
        }
      });
      const reqBody = {
        companyId: this.companyId,
        groupId: this.groupId,
        scopeType,
        isAdd: true,
        conf: list,
        type: 'all'
      };
      this.customerConf(reqBody, true, scopeType);
    },
    // 更新自定义配置
    modifyCustomerConf(xinaluType, xinaluTypeName) {
      if ((this.currentScopeType === 0 && this.currentCompanyId === null) || (this.currentScopeType === 1 && this.currentGroupId === null)) {
        this.$confirm('未选择任何公司或策略组,不能更新自定义配置', '提示', {
          confirmButtonText: '知道了',
          type: 'warning'
        });
        return;
      }
      const ts = xinaluType === 'all' ? '将会更新所有线路!' : `只会更新${xinaluTypeName}类型线路!`;
      this.$confirm(`${ts}您确定要更新吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const list = [];
        // this.message[0].list.forEach((item) => {
        //   item.supplierId = item.id;
        //   if (item.status === 1) {
        //     list.push(item);
        //   }
        // });
        // this.message[1].list.forEach((item) => {
        //   item.supplierId = item.id;
        //   if (item.status === 1) {
        //     list.push(item);
        //   }
        // });
        // this.message[2].list.forEach((item) => {
        //   item.supplierId = item.id;
        //   if (item.status === 1) {
        //     list.push(item);
        //   }
        // });
        // this.message[3].list.forEach((item) => {
        //   item.supplierId = item.id;
        //   if (item.status === 1) {
        //     list.push(item);
        //   }
        // });
        this.messageRes.forEach((item) => {
          item.supplierId = item.id;
          if (item.status === 1) {
            list.push(item);
          }
        });
        const reqBody = {
          scopeType: this.currentScopeType,
          isAdd: false,
          conf: list,
          type: xinaluType
        };
        if (this.currentScopeType === 0) {
          reqBody.companyId = this.currentCompanyId;
        } else {
          reqBody.companyId = this.currentCompanyId;
          reqBody.groupId = this.currentGroupId;
        }
        this.customerConf(reqBody, false, this.currentScopeType);
      });
    },
    customerConf(data, add, scopeType) {
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/externalServicesConf/customerConf',
        data
      }).then(() => {
        if (scopeType === 1) {
          // 新增或编辑的策略组
          if (add) {
            // 新增策略组
            this.company.companySelected = data.companyId;
            this.group = {
              groupOption: [],
              groupSelected: null
            };
            this.supplier.supplierSelected = null;
            this.companyListQuery();
            this.customerConfigureGroup = false;
            this.groupReq = {
              companyId: data.companyId,
              isFilterGroupSetting: false
            };
            this.getGroupOptionList(this.groupReq);
          } else {
            // 编辑策略组
            this.currentScopeType = 1;
            this.currentCompanyIdType = `1_${this.currentCompanyId}_${this.currentGroupId}_${this.currentStatus}`;
            this.companyDetail(this.currentCompanyIdType, 1);
            this.customerConfigureGroup = false;
          }
          return;
        }
        // 新增或编辑的公司
        // 新增后，将新增公司从新增公司下拉框中移除
        if (add) {
          const temp = [];
          this.noneCompanies.forEach((item) => {
            if (item.id !== data.companyId) {
              temp.push(item);
            } else {
              this.addedCompanies.unshift(item);
            }
          });
          this.noneCompanies = temp;
          // 新增后,选中新增公司,也就是获取第一条数据
          if (this.addedCompanies.length > 0) {
            this.currentCompanyId = this.addedCompanies[0].id;
            this.currentScopeType = 0;
            this.currentGroupId = 0;
            this.currentCompanyIdType = `0_${this.currentCompanyId}_0_0`;
            this.currentStatus = '0';
            this.companyDetail(this.currentCompanyIdType, 0);
          }
        } else {
          // 更新数据后,刷新页面信息
          this.companyDetail(this.currentCompanyIdType, this.currentScopeType);
        }
        this.customerConfigure = false;
      });
    },
    delCustomerConf() {
      if ((this.currentScopeType === 0 && this.currentCompanyId === null) || (this.currentScopeType === 1 && this.currentGroupId === null)) {
        this.$confirm('未选择任何公司或策略组, 不能删除', '提示', {
          confirmButtonText: '知道了',
          type: 'warning'
        });
        return;
      }
      this.$confirm('您确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/externalServicesConf/delCustomerConf/${this.currentCompanyId}/${this.currentScopeType}/${this.currentGroupId}`
        }).then(() => {
          if (this.currentScopeType === 1) {
            // 操作的策略组
            this.companyListQuery();
            return;
          }
          const temp = [];
          this.addedCompanies.forEach((item) => {
            if (item.id !== this.currentCompanyId) {
              temp.push(item);
            } else {
              this.noneCompanies.unshift(item);
            }
          });
          this.addedCompanies = temp;
          // 获取第一条数据
          if (this.addedCompanies.length > 0) {
            this.currentCompanyId = this.addedCompanies[0].id;
            this.currentScopeType = 0;
            this.currentGroupId = 0;
            this.currentCompanyIdType = `0_${this.currentCompanyId}_0_0`;
            this.currentStatus = '0';
            this.companyDetail(this.currentCompanyIdType, 0);
          } else {
            // 删除后无配置公司,置空数据
            // this.currentCompanyId = null;
            // this.message[0].list = [];
            // this.message[1].list = [];
            // this.message[2].list = [];
            // this.message[3].list = [];
            this.messageRes = [];
          }
        });
      });
    },
    updateStatusCustomerConf(newStatus) {
      const txt = newStatus ? '打开' : '关闭';
      if (this.currentGroupId === null) {
        this.$confirm(`未选择任何策略组, 不能${txt}`, '提示', {
          confirmButtonText: '知道了',
          type: 'warning'
        });
        return;
      }
      if (this.currentScopeType === 0) {
        this.$confirm(`只能${txt}策略组`, '提示', {
          confirmButtonText: '知道了',
          type: 'warning'
        });
        return;
      }
      this.$confirm(`您确定要${txt}策略组吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'PUT',
          url: `/externalServicesConf/updateStatusCustomerConf/${this.currentGroupId}/${newStatus}`
        }).then(() => {
          const companyId = this.currentCompanyId;
          // 查询它的自定义公司的配置
          this.company.companySelected = companyId;
          this.group = {
            groupOption: [],
            groupSelected: null
          };
          this.supplier.supplierSelected = null;
          this.companyListQuery();
          this.customerConfigureGroup = false;
          this.groupReq = {
            companyId,
            isFilterGroupSetting: false
          };
          this.getGroupOptionList(this.groupReq);
          this.currentStatus = '0';
        });
      });
    },
    companyChange() {
      // 查对应的策略组
      if (this.company.companySelected === null || this.company.companySelected === undefined || this.company.companySelected === '') {
        this.group.groupOption = [];
        this.group.groupSelected = null;
      } else {
        this.groupReq = {
          companyId: this.company.companySelected,
          isFilterGroupSetting: false
        };
        this.group.groupOption = [];
        this.group.groupSelected = null;
        this.getGroupOptionList(this.groupReq);
      }
      this.companyListQuery();
    },
    companyChangeGroup() {
      // 查对应的策略组
      if (this.companyId === null || this.companyId === undefined || this.companyId === '') {
        this.groupAddOption = [];
        this.groupId = null;
      } else {
        this.groupReq = {
          companyId: this.companyId,
          isFilterGroupSetting: true
        };
        this.getGroupAddOptionList(this.groupReq);
      }
      // 把公司线路带过去
      this.companyDetailGroupAdd(`0_${this.companyId}_0_0`, 0);
    },
    // 公司配置列表
    companyDetailGroupAdd(companyIdType, scopeType) {
      const params = companyIdType.split('_');
      const companyId = Number(params[1]);
      const groupId = Number(params[2]);
      this.serversRes = [];
      this.$ajax({
        method: 'GET',
        url: `/externalServicesConf/detail/${companyId}/${scopeType}/${groupId}`
      }).then((res) => {
        this.serversRes = [];
        this.serversRes = res.data;
      });
    },
    getGroupListOnCopyConfigChange(scope, dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        if (scope === 0) {
          this.copyConfigSourceGroupOptions = res.data;
        } else {
          this.copyConfigTargetGroupOptions = res.data;
        }
      });
    },
    getGroupOptionList(dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        this.group.groupOption = res.data;
      });
    },
    getGroupAddOptionList(dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        this.groupAddOption = res.data;
      });
    },
    getSupplier() {
      this.$ajax({
        method: 'GET',
        url: '/externalServicesConf/list'
      }).then((res) => {
        this.supplier.supplierOption = res.data;
      });
    },
    // 获取活动子节点数量
    getActiveChildrenCount(node) {
      if (!node.groupList) return 0;
      return node.groupList.filter(child => child.isGroupSettingOpen).length;
    }
  },
  mounted() {
    this.companyList();
    this.getSupplier();
  }
};
</script>

<style>
/* 复制配置对话框整体优化样式 */
.copy-config-centered .el-dialog {
  width: 650px !important;
  min-height: 450px;
  max-height: 80vh;
  overflow: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.copy-config-centered .el-dialog__header {
  background-color: #f5f7fa;
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  border-radius: 8px 8px 0 0;
}

.copy-config-centered .el-dialog__title {
  font-weight: 600;
  color: #303133;
}

.copy-config-centered .el-dialog__body {
  padding: 25px 30px;
  background-color: #fff;
}

.copy-config-centered .el-form {
  width: 100%;
}

.copy-config-centered .el-form-item {
  margin-bottom: 20px;
}

.copy-config-centered .el-form-item__label {
  font-weight: 600;
  color: #606266;
  padding-right: 20px;
  text-align: right;
}

.copy-config-centered .el-form-item__content {
  position: relative;
}

.copy-config-centered .el-select {
  width: 100%;
}

/* 优化下拉选择框样式 */
.copy-config-centered .el-select .el-input__inner {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.copy-config-centered .el-select:hover .el-input__inner {
  border-color: #c0c4cc;
}

.copy-config-centered .el-select:focus .el-input__inner {
  border-color: #409eff;
}

/* 优化标签显示 */
.copy-config-centered .el-tag {
  margin-right: 5px;
  margin-bottom: 2px;
}

/* 优化对话框底部按钮区域 */
.copy-config-centered .dialog-footer {
  display: flex;
  justify-content: center;
  gap: 15px;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
  background-color: #f5f7fa;
}

.copy-config-centered .el-button {
  min-width: 80px;
  padding: 9px 20px;
  border-radius: 4px;
  font-weight: 500;
}

.copy-config-centered .el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
}

.copy-config-centered .el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.copy-config-centered .el-button--default:hover {
  border-color: #c0c4cc;
  color: #606266;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .copy-config-centered .el-dialog {
    width: 90% !important;
    min-width: 300px;
    margin-top: 5vh;
  }

  .copy-config-centered .el-dialog__body {
    padding: 20px;
  }

  .copy-config-centered .el-form-item__label {
    padding-right: 15px;
    font-size: 14px;
  }
}

  .node-name {
    font-weight: 600;
    color: #606266;
  }
  .field-label {
    color: #686f77;
    margin-right: 0px;
    font-weight: 400;
    font-size: 12px;
  }
  .el-menu-call {
    border: none;
  }
  .el-menu-call .el-menu-item {
    height: 35px;
    line-height: 35px;
    color: #606266;
    font-size: 14px;
    padding-left: 10px;
    cursor: pointer;
    font-weight: 500;
  }
  .el-menu-call .el-submenu__title{
    height: 35px;
    line-height: 35px;
    font-weight: 500;
    padding-left: 0px !important;
  }
  .is-closed {
    color: #C0C4CC;
  }
  .truncated-text {
    display: inline-block; /* 可以设置最大宽度 */
    max-width: 170px; /* 限制宽度后换行效果更好 */
    overflow: hidden;
    text-overflow: ellipsis; /* 省略显示 */
    white-space: nowrap; /* 不允许换行 */
    vertical-align: top; /* 对齐方式调整 */
  }
  .el-menu-call .el-submenu__icon-arrow {
    right: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/page/main/call/custom/index.vue